// ======================================================================
// File Name       : usageStatus
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { LO_SUPER_USER, SUPER_USER } from '../../constants';

export function postGetCurrentStatus(displayUserType) {
    const superUser = [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
    return commonCallApi({
        path: 'usageStatus/GetCurrentStatus',
        enterpriseId: superUser ? 1 : undefined,
    });
  }